/* eslint-disable no-console */

export default async ({ Vue }) => {
  const terminals = [
    'ws',
    'selir',
  ];

  if ((process.env.PROD && terminals.includes(process.env.TERMINALID))) {
    const wsUrl = process.env.PROD
      ? 'ws://localhost:8042'
      : 'ws://10.1.5.7:8042';

    const websocket = await new WebSocket(wsUrl);
    /*
    websocket.onopen = (event) => {
      console.log('WS: Connected');
      console.log(event);
    };

    websocket.onclose = (event) => {
      console.log('WS: Disconnected');
      console.log(event);
    };

    websocket.onmessage = (event) => {
      console.log('WS: Message:', event.data);
      console.log(event);
    };
     */

    websocket.onerror = (event) => {
      this.$bugsnag.notify('WebSocket Error', (e) => {
        e.severity = 'error';
        e.addMetadata('event', event);
      });
    };

    Vue.prototype.$websocket = websocket;
  }
};
